module.exports = __webpack_public_path__ + "img/español.fe31ad8f.svg";